import React, { useState, useEffect } from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import Store from "../../utils/store";
import { Img } from "./styles";
import {
  Flex,
  Button,
  Text,
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/core";
import logo from "../../assets/svg/logo-dark.svg";

const Nav = () => {
  let history = useHistory();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [profile, setProfile] = useState(JSON.parse(Store.getLoggedUserData()));

  useEffect(() => {
    if (Store.getAuthToken()) {
      setIsAuthenticated(true);
      // let userData = JSON.parse(Store.getLoggedUserData())
      // console.log(userData)
      // setProfile(userData)
      // isAuthenticated
    }
    // setPath(history.location.pathname)
  }, []);

  // state = {
  //   path: '',
  //   isAuthenticated: false,
  //   profile: undefined,
  //   redirect: '',
  //   showMenu: false,
  // }
  // componentDidMount() {
  //   if (Store.getAuthToken()) {
  //     this.setState({ isAuthenticated: true })
  //   }
  //   this.setState({ path: this.props.match.path })
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.profile !== this.props.profile) {
  //     this.setState({ profile: nextProps.profile })
  //   }
  // }

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  // render() {
  // if (this.state.redirect) {
  //   return <Redirect to={this.state.redirect} />
  // }
  return (
    <Box shadow="md" paddingY="15px" background="white">
      <Box maxW="1200px" width="95%" margin="0 auto">
        <Flex justifyContent="space-between" alignItems="center">
          <Link to="/">
            <Img src={logo} />
          </Link>

          {!isAuthenticated && <Text fontFamily="Avenir">About</Text>}

          {isAuthenticated && (
            <Menu>
              <MenuButton as={Button} borderRadius="33px" background="#F5F8FA">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 25C5.59625 25 0 19.4037 0 12.5C0 5.59625 5.59625 0 12.5 0C19.4037 0 25 5.59625 25 12.5C25 19.4037 19.4037 25 12.5 25ZM6.26625 20.32C8.03569 21.7346 10.2346 22.5036 12.5 22.5C14.9625 22.5 17.2162 21.61 18.9587 20.135C18.1447 19.2997 17.1713 18.6361 16.0963 18.1835C15.0213 17.7309 13.8664 17.4985 12.7 17.5C11.4907 17.4986 10.2944 17.7486 9.18683 18.234C8.07928 18.7195 7.08473 19.4298 6.26625 20.32ZM4.52 18.525C5.57057 17.4101 6.83834 16.5221 8.24517 15.9159C9.65201 15.3097 11.1681 14.9979 12.7 15C14.1771 14.9981 15.64 15.288 17.0047 15.853C18.3694 16.418 19.6091 17.247 20.6525 18.2925C21.7226 16.7864 22.3545 15.0133 22.4782 13.1699C22.6019 11.3265 22.2124 9.48486 21.3531 7.84932C20.4938 6.21378 19.1982 4.84828 17.61 3.90431C16.0218 2.96033 14.2031 2.4748 12.3558 2.50157C10.5084 2.52833 8.70457 3.06636 7.1444 4.05595C5.58422 5.04554 4.3287 6.448 3.51711 8.10775C2.70553 9.7675 2.36962 11.6196 2.54664 13.4587C2.72367 15.2977 3.40672 17.0518 4.52 18.5262V18.525ZM12.5 13.75C11.1739 13.75 9.90215 13.2232 8.96447 12.2855C8.02678 11.3479 7.5 10.0761 7.5 8.75C7.5 7.42392 8.02678 6.15215 8.96447 5.21447C9.90215 4.27678 11.1739 3.75 12.5 3.75C13.8261 3.75 15.0979 4.27678 16.0355 5.21447C16.9732 6.15215 17.5 7.42392 17.5 8.75C17.5 10.0761 16.9732 11.3479 16.0355 12.2855C15.0979 13.2232 13.8261 13.75 12.5 13.75ZM12.5 11.25C13.163 11.25 13.7989 10.9866 14.2678 10.5178C14.7366 10.0489 15 9.41304 15 8.75C15 8.08696 14.7366 7.45107 14.2678 6.98223C13.7989 6.51339 13.163 6.25 12.5 6.25C11.837 6.25 11.2011 6.51339 10.7322 6.98223C10.2634 7.45107 10 8.08696 10 8.75C10 9.41304 10.2634 10.0489 10.7322 10.5178C11.2011 10.9866 11.837 11.25 12.5 11.25Z"
                    fill="#B17DE5"
                  />
                </svg>
                <Text marginLeft="10px">
                  {profile ? profile.firstName : ""}{" "}
                  {profile ? profile.lastName : ""}
                </Text>
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => history.push("/profile")}>
                  {" "}
                  Settings & Profile
                </MenuItem>
                <MenuItem onClick={() => logout()} color="#B17DE5">
                  Logout
                </MenuItem>
              </MenuList>
            </Menu>
          )}
        </Flex>
      </Box>
    </Box>
  );
  // }
};

export default withRouter(Nav);
